<template>
  <div :class="`modal fade ${showModal ? 'show' : ''}`">
    <div class="needs-validation modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="close" aria-label="Close" @click.stop.prevent="clickClose">
              <span>×</span>
            </button>
          </slot>
        </div>
        <div class="modal-body scrollbar p-3">
          <div class="body-container">
            <slot name="body" />
          </div>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-secondary" @click.stop.prevent="clickClose">Close</button>
            <button type="submit" class="btn btn-primary" @click.stop.prevent="clickSubmit">Submit</button>
          </slot>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" @click.stop.prevent="clickClose"></div>
  </div>
</template>

<script>
export default {
  computed: {
    clickEvents() {
      return Object.assign(
        {
          submit: 'submit',
          close: 'close'
        },
        this.config?.click_events
      )
    }
  },
  methods: {
    clickClose() {
      this.$emit(this.clickEvents.close || 'close', {})
    },
    clickSubmit() {
      this.$emit(this.clickEvents.submit || 'submit', {})
    }
  },
  props: {
    config: Object,
    title: {
      type: String,
      default: ''
    },
    showModal: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  &.show {
    display: flex;
  }
  &:not(.show) {
    visibility: hidden;
  }
  .modal-dialog {
    box-shadow: 0 0 0;
    border-radius: 0;
    width: 100%;
  }
  &.large {
    .modal-dialog {
      width: 90%;
      max-width: 1440px;
    }
  }
  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    border-radius: var(--border-radius, 0.25rem);
    overflow: hidden;
    z-index: 1050;
    .modal-body {
      overflow: auto;
    }
  }
}
</style>
